"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7967],{

/***/ 19205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ DiamondPlusIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var DiamondPlusIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "100%",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M12.4116 9.11084L12.4116 14.8886",
                stroke: "currentColor",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M15.1934 12L9.62957 12",
                stroke: "currentColor",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                d: "M4.87403 12.874L10.5858 18.5858C11.2525 19.2525 11.5858 19.5858 12 19.5858C12.4142 19.5858 12.7475 19.2525 13.4142 18.5858L19.126 12.874C19.5512 12.4488 19.7639 12.2361 19.8291 11.9597C19.8944 11.6832 19.7993 11.3979 19.6091 10.8274L18.9117 8.73509C18.4717 7.41505 18.2517 6.75503 17.7279 6.37752C17.2041 6 16.5084 6 15.117 6H8.88304C7.49159 6 6.79587 6 6.2721 6.37752C5.74832 6.75503 5.52832 7.41505 5.0883 8.73509L4.39088 10.8274C4.2007 11.3979 4.10561 11.6832 4.17087 11.9597C4.23614 12.2361 4.44877 12.4488 4.87403 12.874Z"
            })
        ]
    });
};


/***/ }),

/***/ 59904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);



var JsonLd = function(param) {
    var schema = param.schema;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: JSON.stringify(schema)
            }
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(JsonLd));


/***/ }),

/***/ 34794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81703);
/* harmony import */ var _contexts_profile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48309);




var TitlePartial = function(param) {
    var name = param.name, className = param.className, cs = param.cs;
    var masterData = (0,_contexts_profile__WEBPACK_IMPORTED_MODULE_2__/* .useMasterData */ .AE)();
    var theme = (masterData !== null && masterData !== void 0 ? masterData : {}).theme;
    var icon_category_url = (theme !== null && theme !== void 0 ? theme : {}).icon_category_url;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "_title tw-text-lg md:tw-text-2xl tw-flex tw-items-center tw-justify-center  tw-w-full  tw-relative ".concat(className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "tw-flex tw-items-center tw-w-max tw-px-5 tw-justify-center ",
            children: [
                icon_category_url ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_3__/* .Image */ .E, {
                    src: icon_category_url,
                    alt: "star",
                    className: "tw-h-8 tw-w-8"
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_3__/* .Image */ .E, {
                    src: "/diamond.svg",
                    alt: "star",
                    className: "tw-h-5 tw-w-5"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "tw-flex-1 tw-block tw-px-4 tw-uppercase tw-text-primary-main tw-font-semibold ".concat(cs),
                    children: name
                }),
                icon_category_url ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_3__/* .Image */ .E, {
                    src: icon_category_url,
                    alt: "star",
                    className: "tw-h-8 tw-w-8"
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_3__/* .Image */ .E, {
                    src: "/diamond.svg",
                    alt: "star",
                    className: "tw-h-5 tw-w-5"
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(TitlePartial));


/***/ }),

/***/ 57967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ detail; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/ui/Icon/index.tsx
var Icon = __webpack_require__(58262);
// EXTERNAL MODULE: ./components/icons/LoadingSpin/index.tsx
var LoadingSpin = __webpack_require__(93007);
// EXTERNAL MODULE: ./features/livestream/shared.ts
var shared = __webpack_require__(83134);
// EXTERNAL MODULE: ./components/ui/Title/index.tsx
var Title = __webpack_require__(34794);
// EXTERNAL MODULE: ./features/livestream/detail/api.ts
var api = __webpack_require__(77910);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/react-hot-toast.esm.js + 1 modules
var react_hot_toast_esm = __webpack_require__(74931);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 137 modules
var motion = __webpack_require__(83749);
// EXTERNAL MODULE: ./components/loop/VideoLoop.tsx
var VideoLoop = __webpack_require__(30161);
;// CONCATENATED MODULE: ./features/livestream/detail/partials/list/index.tsx









var ListPartial = function(param) {
    var t = param.t;
    var ref = (0,react.useState)(shared/* LiveVideosDefault */.y), liveVideosCursor = ref[0], setLiveVideosCursor = ref[1];
    var ref1 = (0,api/* useFetchLiveVideosQuery */.fN)({
        limit: 4,
        offset: 0
    }, {
        enabled: false,
        retry: false,
        refetchOnWindowFocus: false,
        onError: function(data) {
            react_hot_toast_esm/* default.error */.ZP.error(data.message);
        },
        onSuccess: function(param) {
            var data = param.data, totalRecords = param.total_records;
            var edges = Array.isArray(data) ? data : [];
            setLiveVideosCursor({
                edges: edges,
                count: +totalRecords
            });
        }
    }), refetch = ref1.refetch, isLoading = ref1.isLoading;
    (0,react.useEffect)(function() {
        refetch();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                name: t("detail.list-live-title"),
                className: "_title-live-detail"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-flex tw-flex-col tw-mt-10",
                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-h-10 tw-flex tw-justify-center tw-items-center tw-text-primary-main",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpin/* LoadingSpin64 */.h, {})
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                    initial: "mainInitial",
                    animate: "mainAnimate",
                    exit: "mainExit",
                    variants: {
                        mainInitial: {
                            opacity: 0
                        },
                        mainAnimate: {
                            opacity: 1,
                            transition: {
                                duration: 0.4
                            }
                        },
                        mainExit: {
                            opacity: 0
                        }
                    },
                    children: !!liveVideosCursor.edges && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-grid tw-grid-cols-2 md:tw-grid-cols-4 tw-gap-2 md:tw-gap-4",
                        children: liveVideosCursor.edges.map(function(v) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoLoop/* VideoLoop */.W, {
                                v: v,
                                t: t
                            }, v.id);
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var list = (/*#__PURE__*/(0,react.memo)(ListPartial));

// EXTERNAL MODULE: ./components/ui/Image/index.tsx
var Image = __webpack_require__(81703);
// EXTERNAL MODULE: ./components/ui/Button/index.tsx
var Button = __webpack_require__(73055);
// EXTERNAL MODULE: ./components/icons/XLine/index.tsx
var XLine = __webpack_require__(4408);
// EXTERNAL MODULE: ./components/ui/ModalCustom/index.tsx
var ModalCustom = __webpack_require__(8101);
// EXTERNAL MODULE: ./models/conversation.ts
var conversation = __webpack_require__(41773);
// EXTERNAL MODULE: ./features/livestream/detail/const.ts
var detail_const = __webpack_require__(98346);
// EXTERNAL MODULE: ./layouts/shared.ts
var layouts_shared = __webpack_require__(7806);
// EXTERNAL MODULE: ./contexts/profile/index.tsx
var contexts_profile = __webpack_require__(48309);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./components/ui/Select/index.tsx
var Select = __webpack_require__(73786);
// EXTERNAL MODULE: ./components/ui/Avatar/index.tsx
var Avatar = __webpack_require__(55743);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./features/livestream/detail/util.ts
var util = __webpack_require__(53154);
// EXTERNAL MODULE: ./libs/dayjs/index.ts
var dayjs = __webpack_require__(74865);
;// CONCATENATED MODULE: ./features/livestream/detail/partials/chat/Comments/ReplyComment.tsx





var ReplyComment = function(props) {
    var ref, ref1;
    var replyComment = props.replyComment, fullName = props.fullName;
    var _user = (replyComment === null || replyComment === void 0 ? void 0 : replyComment.facebook_comment_info) ? {
        fullname: (replyComment === null || replyComment === void 0 ? void 0 : (ref = replyComment.facebook_comment_info) === null || ref === void 0 ? void 0 : ref.facebook_user.first_name) || "",
        avatar: (replyComment === null || replyComment === void 0 ? void 0 : (ref1 = replyComment.facebook_comment_info) === null || ref1 === void 0 ? void 0 : ref1.facebook_user.avatar_url) || ""
    } : null;
    var ref2 = (0,util/* getCommentAuthor */.G)(_user ? _user : null, (replyComment === null || replyComment === void 0 ? void 0 : replyComment.staffs) ? replyComment === null || replyComment === void 0 ? void 0 : replyComment.staffs : null), replyName = ref2.fullname, avatar = ref2.avatar;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-flex tw-gap-x-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* Avatar */.q, {
                alt: replyName,
                src: avatar || "",
                className: "tw-w-5 tw-h-5",
                rounded: "tw-rounded-full"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-bg-white tw-px-4 tw-py-1 tw-rounded-b-lg tw-rounded-lg tw-relative tw-flex-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        dangerouslySetInnerHTML: {
                            __html: replyName
                        },
                        className: "text-user-chat tw-font-normal tw-text-13 tw-line-clamp-1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "tw-text-secondary-70 tw-text-13",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: fullName
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                dangerouslySetInnerHTML: {
                                    __html: (replyComment === null || replyComment === void 0 ? void 0 : replyComment.comment) || ""
                                }
                            })
                        ]
                    }),
                    (replyComment === null || replyComment === void 0 ? void 0 : replyComment.updated_at) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-text-right tw-text-secondary-50",
                        style: {
                            fontSize: "10px"
                        },
                        children: (0,dayjs/* humanTimeDate */.EM)(replyComment === null || replyComment === void 0 ? void 0 : replyComment.updated_at)
                    })
                ]
            })
        ]
    }, "reply-comment-" + (replyComment === null || replyComment === void 0 ? void 0 : replyComment.id));
};

// EXTERNAL MODULE: ./node_modules/react-infinite-scroll-component/dist/index.es.js
var index_es = __webpack_require__(58533);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 4 modules
var AnimatePresence = __webpack_require__(65820);
// EXTERNAL MODULE: ./features/livestream/detail/partials/chat/Comments/Products.tsx
var Products = __webpack_require__(6501);
// EXTERNAL MODULE: ./libs/app/index.ts + 40 modules
var app = __webpack_require__(41255);
;// CONCATENATED MODULE: ./features/livestream/detail/partials/chat/Comments/index.tsx



















// eslint-disable-next-line react/display-name
var CommentPartial = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var liveId = param.liveId, isAuth = param.isAuth, messageData = param.messageData, commentList = param.commentList, defaultOffset = param.defaultOffset, isShowProducts = param.isShowProducts, hiddenProducts = param.hiddenProducts, t = param.t, sendComment = param.sendComment;
    var _$ref, _$ref1, _$ref2, _$ref3;
    var profile = (0,contexts_profile/* useProfile */.Un)();
    var userId = (profile === null || profile === void 0 ? void 0 : profile.id) || null;
    var _$ref4 = (0,react.useState)(0), offset = _$ref4[0], setOffset = _$ref4[1];
    var _$ref5 = (0,react.useState)(commentList), comments = _$ref5[0], setComments = _$ref5[1];
    var _$ref6 = (0,react.useState)(""), selected = _$ref6[0], setSelected = _$ref6[1];
    var router = (0,next_router.useRouter)();
    var filterCommentOption = [
        {
            label: "Ph\xf9 hợp nhất",
            value: "my"
        },
        {
            label: "Xem tất cả",
            value: "all"
        }, 
    ];
    var commentEl = (0,react.useRef)(null);
    var _$ref7 = (0,api/* useFetchCommentsQuery */.iq)({
        id: +liveId,
        offset: offset
    }, {
        enabled: false,
        onError: function(param) {
            var message = param.message;
            react_hot_toast_esm/* default.error */.ZP.error(message);
        },
        onSuccess: function(param) {
            var data = param.data;
            var _comments = Array.isArray(data) ? data : [];
            // setComments(comments.sort((a, b) => a.id - b.id));
            _comments.forEach(function(comment) {
                setComments(function(prev) {
                    if (!prev.find(function(p) {
                        return p.id === comment.id;
                    })) return (0,_to_consumable_array/* default */.Z)(prev).concat([
                        comment
                    ]);
                    else return (0,_to_consumable_array/* default */.Z)(prev);
                });
            });
        }
    }), refetchComments = _$ref7.refetch, isLoadingComments = _$ref7.isLoading;
    var _$ref8 = (0,api/* useFetchCommentsQuery */.iq)({
        id: +liveId,
        offset: 0
    }, {
        enabled: false,
        onError: function(param) {
            var message = param.message;
            react_hot_toast_esm/* default.error */.ZP.error(message);
        },
        onSuccess: function(param) {
            var data = param.data;
            var comments = Array.isArray(data) ? data : [];
            // setComments(comments.sort((a, b) => a.id - b.id));
            setComments(comments);
        }
    }), refetchFirstComments = _$ref8.refetch;
    var _$ref9 = (0,api/* useFetchCommentByIdQuery */.aH)(((_$ref = router.query) === null || _$ref === void 0 ? void 0 : _$ref.comment_id) ? +((_$ref1 = router.query) === null || _$ref1 === void 0 ? void 0 : _$ref1.comment_id) : 0, {
        enabled: false,
        onError: function(param) {
            var message = param.message;
            react_hot_toast_esm/* default.error */.ZP.error(message);
        },
        onSuccess: function(param) {
            var data = param.data;
            if (typeof data == "object") setComments([
                data
            ]);
        // setComments((prev) => prev.concat(comments));
        }
    }), refetchComment = _$ref9.refetch;
    var scrollToBottom = function() {
        var parent = document.getElementById("scrollableDiv");
        if (parent && commentEl && comments.length) {
            parent.scrollTop = commentEl.current.scrollHeight;
        }
    };
    var loadFunc = function() {
        setOffset(function(prev) {
            return prev + 20;
        });
    };
    var removeEventLottery = function() {
        setTimeout(function() {
            setComments(function(prev) {
                var arr = prev.filter(function(c) {
                    return c.type !== "lottery";
                });
                return (0,_to_consumable_array/* default */.Z)(arr);
            });
        }, 10000);
    };
    var handleSelect = function(data) {
        setSelected(data.value);
        if (!isAuth) return;
        scrollToBottom();
        setOffset(0);
        if (data.value === filterCommentOption[0].value) refetchComment();
        else {
            refetchFirstComments();
        }
    };
    (0,react.useEffect)(function() {
        setComments(commentList);
    }, [
        commentList
    ]);
    (0,react.useImperativeHandle)(ref, function() {
        return {
            scrollToBottom: function() {
                scrollToBottom();
            }
        };
    });
    (0,react.useEffect)(function() {
        var _$ref;
        scrollToBottom();
        setOffset(defaultOffset);
        if ((_$ref = router.query) === null || _$ref === void 0 ? void 0 : _$ref.comment_id) {
            setSelected(filterCommentOption[0].value);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        liveId,
        defaultOffset,
        (_$ref2 = router.query) === null || _$ref2 === void 0 ? void 0 : _$ref2.comment_id
    ]);
    (0,react.useEffect)(function() {
        if (!messageData) return;
        if (messageData.method === layouts_shared/* CommentMethod.CreateComment */.iz.CreateComment || messageData.method === layouts_shared/* CommentMethod.UnHideComment */.iz.UnHideComment) {
            if (!messageData.data.comment) return;
            scrollToBottom();
            return setComments(function(prev) {
                return [
                    messageData === null || messageData === void 0 ? void 0 : messageData.data
                ].concat((0,_to_consumable_array/* default */.Z)(prev));
            });
        }
        if (messageData.method === layouts_shared/* CommentMethod.DeleteComment */.iz.DeleteComment || messageData.method === layouts_shared/* CommentMethod.HideComment */.iz.HideComment) {
            scrollToBottom();
            setComments(function(prev) {
                var _c = prev.filter(function(v) {
                    return v.id !== (messageData === null || messageData === void 0 ? void 0 : messageData.data.comment_id);
                });
                return _c;
            });
        }
        if (messageData.method === layouts_shared/* CommentMethod.CreateReplyComment */.iz.CreateReplyComment || messageData.method === layouts_shared/* CommentMethod.UnHideReplyComment */.iz.UnHideReplyComment) {
            setComments(function(prev) {
                var _c = (0,lodash.forEach)(prev, function(m) {
                    if (m.id === messageData.data.parent_id) {
                        m.reply_comments ? m.reply_comments.push(messageData === null || messageData === void 0 ? void 0 : messageData.data) : m.reply_comments = [
                            messageData === null || messageData === void 0 ? void 0 : messageData.data
                        ];
                    }
                });
                return _c;
            });
        }
        if (messageData.method === layouts_shared/* CommentMethod.DeleteReplyComment */.iz.DeleteReplyComment || messageData.method === layouts_shared/* CommentMethod.HideReplyComment */.iz.HideReplyComment) {
            setComments(function(prev) {
                var _c = (0,lodash.forEach)(prev, function(m) {
                    if (m.id === messageData.data.comment_id) {
                        var _$ref;
                        m.reply_comments = m === null || m === void 0 ? void 0 : (_$ref = m.reply_comments) === null || _$ref === void 0 ? void 0 : _$ref.filter(function(c) {
                            return c.id !== messageData.data.reply_comment_id;
                        });
                    }
                });
                return _c;
            });
        }
        if (messageData.method === layouts_shared/* CommentMethod.UpdateComment */.iz.UpdateComment) {
            setComments(function(prev) {
                var _c = (0,lodash.forEach)(prev, function(m) {
                    if (m.id === messageData.data.id) {
                        m.comment = messageData.data.comment;
                    }
                });
                return _c;
            });
        }
        if (messageData.method === layouts_shared/* CommentMethod.UpdateReplyComment */.iz.UpdateReplyComment) {
            setComments(function(prev) {
                var _c = (0,lodash.forEach)(prev, function(m) {
                    if (m.id === messageData.data.parent_id) {
                        var _$ref;
                        var c = m === null || m === void 0 ? void 0 : (_$ref = m.reply_comments) === null || _$ref === void 0 ? void 0 : _$ref.find(function(c) {
                            return c.id === messageData.data.id;
                        });
                        if (c) c.comment = messageData.data.comment;
                    }
                });
                return _c;
            });
        }
        if (messageData.method === layouts_shared/* LotterySocketMethod.OpenLottery */.Sf.OpenLottery) {
            setComments(function(prev) {
                var _m = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, messageData.data), {
                    comment: "Bắt đầu xổ số",
                    type: "lottery"
                });
                return [
                    _m
                ].concat((0,_to_consumable_array/* default */.Z)(prev));
            });
        }
        if (messageData.method === layouts_shared/* LotterySocketMethod.EndLottery */.Sf.EndLottery) {
            setComments(function(prev) {
                var _m = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, messageData.data), {
                    comment: "Kết th\xfac xổ số",
                    type: "lottery"
                });
                return [
                    _m
                ].concat((0,_to_consumable_array/* default */.Z)(prev));
            });
            removeEventLottery();
        }
        if (messageData.method === layouts_shared/* LotterySocketMethod.CloseListLottery */.Sf.CloseListLottery) {
            setComments(function(prev) {
                var _m = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, messageData.data), {
                    comment: "Chốt danh s\xe1ch xổ số",
                    type: "lottery"
                });
                return [
                    _m
                ].concat((0,_to_consumable_array/* default */.Z)(prev));
            });
        }
        if (messageData.method === layouts_shared/* LotterySocketMethod.AdminPickTicketLottery */.Sf.AdminPickTicketLottery) {
            setComments(function(prev) {
                var _m = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, messageData.data), {
                    comment: "Kết quả sổ số: " + messageData.data.number,
                    type: "lottery"
                });
                return [
                    _m
                ].concat((0,_to_consumable_array/* default */.Z)(prev));
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        messageData,
        messageData === null || messageData === void 0 ? void 0 : messageData.data.id
    ]);
    (0,react.useEffect)(function() {
        if (!isAuth) return;
        if (!isLoadingComments && offset && selected !== filterCommentOption[0].value) {
            refetchComments();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        offset,
        isLoadingComments,
        isAuth,
        selected
    ]);
    var getCommentUser = function(comment) {
        var users = comment.users, facebook_comment_info = comment.facebook_comment_info, youtube_comment_info = comment.youtube_comment_info, tiktok_comment_info = comment.tiktok_comment_info;
        if (users) {
            return users;
        }
        if (facebook_comment_info) {
            return {
                fullname: (facebook_comment_info === null || facebook_comment_info === void 0 ? void 0 : facebook_comment_info.facebook_user.first_name) || "",
                avatar: (facebook_comment_info === null || facebook_comment_info === void 0 ? void 0 : facebook_comment_info.facebook_user.avatar_url) || ""
            };
        }
        if (youtube_comment_info) {
            return {
                fullname: (youtube_comment_info === null || youtube_comment_info === void 0 ? void 0 : youtube_comment_info.youtube_user.first_name) || "",
                avatar: (youtube_comment_info === null || youtube_comment_info === void 0 ? void 0 : youtube_comment_info.youtube_user.avatar_url) || ""
            };
        }
        if (tiktok_comment_info) {
            return {
                fullname: (tiktok_comment_info === null || tiktok_comment_info === void 0 ? void 0 : tiktok_comment_info.tiktok_user.first_name) || "",
                avatar: (tiktok_comment_info === null || tiktok_comment_info === void 0 ? void 0 : tiktok_comment_info.tiktok_user.avatar_url) || ""
            };
        }
        return null;
    };
    var renderCampaignQuizWinComment = function(comment) {
        var _$ref, _$ref1, _$ref2;
        var commentAttachment = comment === null || comment === void 0 ? void 0 : (_$ref = comment.comment_attachments) === null || _$ref === void 0 ? void 0 : _$ref[0];
        if (!commentAttachment) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        var prize = (_$ref1 = commentAttachment.data) === null || _$ref1 === void 0 ? void 0 : _$ref1.prize;
        var _$ref3;
        var wonComments = (_$ref3 = (_$ref2 = commentAttachment.data) === null || _$ref2 === void 0 ? void 0 : _$ref2.won_comments) !== null && _$ref3 !== void 0 ? _$ref3 : [];
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                wonComments.map(function(i) {
                    var _$ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-user-chat tw-text-13 tw-font-bold tw-flex tw-items-center tw-gap-1",
                            children: [
                                (_$ref = getCommentUser(i)) === null || _$ref === void 0 ? void 0 : _$ref.fullname,
                                i.facebook_comment_info && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                    src: "/facebook-color.png",
                                    alt: "Facebook",
                                    className: "tw-w-4 tw-h-4 tw-rounded-full"
                                }),
                                i.youtube_comment_info && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                    src: "/youtube.svg",
                                    alt: "Youtube",
                                    className: "tw-w-4 tw-h-4 tw-rounded-full"
                                })
                            ]
                        })
                    }, "comment-".concat(i.id));
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "tw-text-secondary-70 tw-text-13 tw-font-normal",
                    children: [
                        "Bạn đ\xe3 nhận được ",
                        prize === null || prize === void 0 ? void 0 : prize.reward_content,
                        " từ An Thư"
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            ((_$ref3 = router.query) === null || _$ref3 === void 0 ? void 0 : _$ref3.comment_id) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-w-max tw-z-10 tw-bg-muted-90",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* SelectCustom */.u, {
                    className: "tw-h-7 tw-text-xs !tw-px-2 !tw-w-40",
                    options: filterCommentOption,
                    handleSelect: handleSelect
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-relative tw-w-full tw-flex-1 tw-overflow-hidden tw-block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "scrollableDiv",
                        className: "tw-relative",
                        style: {
                            overflow: "auto",
                            display: "flex",
                            flexDirection: "column-reverse",
                            height: "100%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                            dataLength: comments.length,
                            next: loadFunc,
                            style: {
                                display: "flex",
                                height: "100%",
                                flexDirection: "column-reverse"
                            },
                            inverse: true,
                            hasMore: true,
                            loader: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                            // className="tw-gap-y-4"
                            scrollableTarget: "scrollableDiv",
                            ref: commentEl,
                            children: comments.map(function(item) {
                                var _$ref, _$ref1, _$ref2, _$ref3, _$ref4, _$ref5, _$ref6;
                                var comment = item.comment, id = item.id, staffs = item.staffs, type = item.type, reply_comments = item.reply_comments, facebook_comment_info = item.facebook_comment_info, youtube_comment_info = item.youtube_comment_info, tiktok_comment_info = item.tiktok_comment_info, created_at = item.created_at, comment_attachments = item.comment_attachments;
                                var _user = getCommentUser(item);
                                var replyComments = Array.from(new Set(reply_comments)).length > 0 ? reply_comments === null || reply_comments === void 0 ? void 0 : reply_comments.sort(function(a, b) {
                                    return a && new Date(a.updated_at).getTime() - new Date(b.updated_at).getTime();
                                }) : [];
                                var _$ref7 = (0,util/* getCommentAuthor */.G)(_user, staffs ? staffs : null), fullName = _$ref7.fullname, avatar = _$ref7.avatar;
                                if (!comment) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                                if (type === "lottery") return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-flex tw-justify-center tw-mt-4",
                                    children: item.number ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "tw-text-secondary-91 tw-flex tw-items-center tw-text-13 tw-py-2 tw-px-9 tw-rounded-2xl",
                                            style: {
                                                background: "rgba(0, 0, 0, 0.06)"
                                            },
                                            children: [
                                                comment,
                                                [
                                                    1,
                                                    2,
                                                    3
                                                ].map(function(i) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                                        src: "/confetti-flat.gif",
                                                        alt: "confetti",
                                                        className: "tw-w-6 tw-h-6 ".concat(i == 1 && " tw-ml-1")
                                                    }, "i-".concat(1));
                                                })
                                            ]
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tw-text-secondary-91 tw-text-13 tw-py-2 tw-px-9 tw-rounded-2xl",
                                                style: {
                                                    background: "rgba(0, 0, 0, 0.06)"
                                                },
                                                children: comment
                                            })
                                        ]
                                    })
                                }, comment + "-" + new Date().getTime());
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "tw-flex tw-gap-x-2 tw-w-full tw-mt-4 tw-items-end",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* Avatar */.q, {
                                                    alt: fullName,
                                                    src: avatar || "",
                                                    className: "tw-w-8 tw-h-8 tw-mt-6",
                                                    rounded: "tw-rounded-full"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "tw-flex-1",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "tw-w-full",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "tw-bg-white tw-px-4 tw-py-1 tw-rounded-t-lg tw-rounded-br-lg tw-relative custom-polygon-bottom",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "text-user-chat tw-font-bold tw-text-13 tw-flex tw-items-center",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            dangerouslySetInnerHTML: {
                                                                                __html: item.comment_attachments && item.comment_attachments[0] && [
                                                                                    "AUCTION_TOP_OFFER_HIGHEST_PRICE",
                                                                                    "CAMPAIGN_QUIZ_WIN", 
                                                                                ].includes((_$ref = item.comment_attachments[0]) === null || _$ref === void 0 ? void 0 : _$ref.type) ? "An Thư Kim Cương" : fullName
                                                                            }
                                                                        }),
                                                                        !!facebook_comment_info && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                                                            className: "tw-w-3 tw-h-3 tw-ml-2",
                                                                            src: "/fb-mini.png",
                                                                            alt: "fb-min"
                                                                        }),
                                                                        !!youtube_comment_info && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                                                            className: "tw-w-3 tw-h-3 tw-ml-2",
                                                                            src: "/youtube-mini.png",
                                                                            alt: "ytb-min"
                                                                        }),
                                                                        !!tiktok_comment_info && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                                                            className: "tw-w-3 tw-h-3 tw-ml-2",
                                                                            src: "/tiktok-mini.webp",
                                                                            alt: "ttk-min"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "tw-text-secondary-70 tw-text-13 tw-font-normal",
                                                                    children: comment
                                                                }),
                                                                item.comment_attachments && item.comment_attachments.length > 0 && ((_$ref1 = item.comment_attachments[0]) === null || _$ref1 === void 0 ? void 0 : _$ref1.type) === "AUCTION_TOP_OFFER_HIGHEST_PRICE" && ((_$ref2 = item.comment_attachments[0]) === null || _$ref2 === void 0 ? void 0 : (_$ref3 = _$ref2.data) === null || _$ref3 === void 0 ? void 0 : _$ref3.user_auction) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "tw-py-2 tw-text-13 tw-w-full tw-bg-white tw-rounded tw-mx-auto",
                                                                    style: {
                                                                        minWidth: 350
                                                                    },
                                                                    children: (_$ref4 = item.comment_attachments[0]) === null || _$ref4 === void 0 ? void 0 : (_$ref5 = _$ref4.data) === null || _$ref5 === void 0 ? void 0 : _$ref5.user_auction.sort(function(a, b) {
                                                                        return b.price - a.price;
                                                                    }).slice(0, 3).map(function(u, i) {
                                                                        var _$ref, _$ref1, _$ref2, _$ref3;
                                                                        var name = u.type === "FACEBOOK" ? (_$ref = u.facebook_user) === null || _$ref === void 0 ? void 0 : _$ref.first_name : (_$ref1 = u.users) === null || _$ref1 === void 0 ? void 0 : _$ref1.fullname;
                                                                        var avatar = u.type === "FACEBOOK" ? (_$ref2 = u.facebook_user) === null || _$ref2 === void 0 ? void 0 : _$ref2.avatar_url : (_$ref3 = u.users) === null || _$ref3 === void 0 ? void 0 : _$ref3.avatar;
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "tw-flex tw-items-center tw-py-1 tw-gap-1 tw-text-[11px]",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                    children: [
                                                                                        i + 1,
                                                                                        "."
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* Avatar */.q, {
                                                                                    alt: name,
                                                                                    src: avatar || "",
                                                                                    className: "tw-w-5 tw-h-5 tw-mx-1",
                                                                                    rounded: "tw-rounded-full"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    children: name
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    children: "-"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: "tw-font-bold",
                                                                                    children: (0,app/* toMoney */.KP)(u.price, t, layouts_shared/* PriceSymbol.$ */.hb.$)
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    children: "/"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "tw-text-secondary-50",
                                                                                            children: "Thời gian:"
                                                                                        }),
                                                                                        " ",
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                                            children: u.created_at ? (0,dayjs/* formatTimeHMSS */.i5)(u.created_at) : "--:--:--"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }, "top-auction-".concat(name, "-").concat(u.price));
                                                                    })
                                                                }),
                                                                comment_attachments && comment_attachments[0] && comment_attachments[0].type === "CAMPAIGN_QUIZ_WIN" && ((_$ref6 = comment_attachments[0].data) === null || _$ref6 === void 0 ? void 0 : _$ref6.won_comments) && renderCampaignQuizWinComment(item),
                                                                created_at && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "tw-text-right tw-text-secondary-50",
                                                                    style: {
                                                                        fontSize: "10px"
                                                                    },
                                                                    children: (0,dayjs/* humanTimeDate */.EM)(created_at)
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "tw-flex",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "tw-w-9"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "tw-flex-1",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "tw-w-3/4",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: replyComments && (replyComments === null || replyComments === void 0 ? void 0 : replyComments.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "tw-flex tw-flex-col tw-mt-2 tw-gap-y-2",
                                                                    children: replyComments === null || replyComments === void 0 ? void 0 : replyComments.map(function(rC) {
                                                                        return rC && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReplyComment, {
                                                                            fullName: fullName,
                                                                            replyComment: rC
                                                                        }, "rep-".concat(id, "-").concat(rC === null || rC === void 0 ? void 0 : rC.id));
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, "comment-" + id + "-" + created_at);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                        children: isShowProducts && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                            initial: {
                                height: 0,
                                opacity: 0
                            },
                            animate: {
                                height: "100%",
                                opacity: 1
                            },
                            exit: {
                                height: 0,
                                opacity: 0
                            },
                            transition: {
                                duration: 0.5
                            },
                            className: "tw-absolute tw-bottom-0 tw-left-0 tw-bg-transparent tw-h-full tw-w-full tw-rounded-lg tw-max-h-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Products/* default */.Z, {
                                userId: userId,
                                sendComment: sendComment,
                                onClose: hiddenProducts,
                                liveId: liveId,
                                t: t
                            })
                        })
                    })
                ]
            })
        ]
    });
});
/* harmony default export */ var Comments = (CommentPartial);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./components/icons/XIcon/index.tsx
var XIcon = __webpack_require__(42785);
// EXTERNAL MODULE: ./components/icons/Diamond/index.tsx
var Diamond = __webpack_require__(38843);
// EXTERNAL MODULE: ./components/form/TextField/index.tsx
var TextField = __webpack_require__(40717);
// EXTERNAL MODULE: ./components/ui/Input/index.tsx
var Input = __webpack_require__(19747);
// EXTERNAL MODULE: ./components/icons/Send/index.tsx
var Send = __webpack_require__(16354);
;// CONCATENATED MODULE: ./components/icons/Flower/index.tsx


var FlowerIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 19 18",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.49354 11.5273C10.5784 11.5273 11.4578 10.6537 11.4578 9.57615C11.4578 8.49856 10.5784 7.625 9.49354 7.625C8.40872 7.625 7.5293 8.49856 7.5293 9.57615C7.5293 10.6537 8.40872 11.5273 9.49354 11.5273Z",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.8355 7.06297C17.557 6.21601 16.9538 5.51418 16.1584 5.11154C15.3629 4.70889 14.4402 4.63835 13.5928 4.91539C13.2903 5.00111 13.0031 5.13367 12.7416 5.30824C12.8262 5.0055 12.8703 4.69285 12.8725 4.3785C12.8725 3.48247 12.5166 2.62313 11.883 1.98954C11.2494 1.35595 10.3901 1 9.49404 1C8.598 1 7.73867 1.35595 7.10508 1.98954C6.47149 2.62313 6.11554 3.48247 6.11554 4.3785C6.11782 4.69285 6.16185 5.0055 6.24649 5.30824C5.98584 5.12907 5.69859 4.99208 5.39532 4.9023C4.97658 4.76559 4.53502 4.71269 4.09584 4.74662C3.65666 4.78056 3.22846 4.90067 2.8357 5.10009C2.44294 5.29951 2.0933 5.57434 1.80676 5.90888C1.52021 6.24343 1.30236 6.63114 1.16564 7.04987C1.02893 7.46861 0.976033 7.91017 1.00997 8.34935C1.04391 8.78853 1.16402 9.21672 1.36344 9.60948C1.56286 10.0022 1.83768 10.3519 2.17223 10.6384C2.50677 10.925 2.89448 11.1428 3.31322 11.2795C3.61993 11.3701 3.93655 11.4229 4.25605 11.4367C4.01199 11.6324 3.79218 11.8566 3.60131 12.1045C3.34059 12.4595 3.15296 12.8627 3.0493 13.2907C2.94564 13.7187 2.92802 14.1631 2.99746 14.598C3.06689 15.0329 3.22201 15.4497 3.4538 15.8241C3.68559 16.1986 3.98944 16.5233 4.34772 16.7794C5.07172 17.3026 5.9729 17.5191 6.85555 17.3818C7.73819 17.2445 8.53104 16.7645 9.0619 16.0461C9.24611 15.7894 9.39171 15.507 9.49404 15.208C9.60044 15.5078 9.75046 15.7902 9.93927 16.0461C10.4701 16.7645 11.263 17.2445 12.1456 17.3818C13.0283 17.5191 13.9294 17.3026 14.6535 16.7794C15.0117 16.5233 15.3156 16.1986 15.5474 15.8241C15.7792 15.4497 15.9343 15.0329 16.0037 14.598C16.0732 14.1631 16.0555 13.7187 15.9519 13.2907C15.8482 12.8627 15.6606 12.4595 15.3999 12.1045C15.209 11.8566 14.9892 11.6324 14.7451 11.4367C15.0602 11.4218 15.3724 11.3691 15.6749 11.2795C16.0944 11.1458 16.4834 10.9304 16.8194 10.6457C17.1554 10.3611 17.4317 10.0127 17.6326 9.62084C17.8334 9.22892 17.9547 8.80116 17.9895 8.36217C18.0244 7.92319 17.972 7.48164 17.8355 7.06297V7.06297Z",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/ui/Modal/index.tsx
var Modal = __webpack_require__(15203);
// EXTERNAL MODULE: ./components/ui/Link/index.tsx
var Link = __webpack_require__(43701);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.module.js + 1 modules
var yup_module = __webpack_require__(95496);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./components/ui/Loading/index.tsx
var Loading = __webpack_require__(51945);
// EXTERNAL MODULE: ./components/icons/DiamondPlus/index.tsx
var DiamondPlus = __webpack_require__(19205);
;// CONCATENATED MODULE: ./features/livestream/detail/partials/chat/SendSticker/index.tsx








var SendSticker = function(param) {
    var collectionStickers = param.collectionStickers, sendSticker = param.sendSticker, t = param.t, giftAtd = param.giftAtd, isLoading = param.isLoading;
    var ref, ref1, ref2;
    var router = (0,next_router.useRouter)();
    var ref3 = (0,react.useState)(collectionStickers[0].name), collection = ref3[0], setCollection = ref3[1];
    var ref4 = (0,react.useState)([]), listSticker = ref4[0], setListSticker = ref4[1];
    var masterData = (0,contexts_profile/* useMasterData */.AE)();
    var ref5 = (0,react.useState)(), sticker = ref5[0], setSticker = ref5[1];
    var ref6 = (0,react.useState)(0), atd = ref6[0], setAtd = ref6[1];
    var ref7 = (0,api/* useStickerQuery */.g)({
        collection: collection != "send-atd" ? collection : collectionStickers[0].name,
        offset: 0,
        limit: 100
    }, {
        enabled: false,
        refetchOnWindowFocus: false,
        onSuccess: function(data) {
            setListSticker(data.data);
        }
    }), refetchSticker = ref7.refetch, isLoadingStickers = ref7.isLoading;
    var chooseSticker = (0,react.useCallback)(function() {
        var ref;
        if (atd && collection === "send-atd") return giftAtd(atd);
        var collectionStickerId = (ref = collectionStickers.find(function(c) {
            return c.name === collection;
        })) === null || ref === void 0 ? void 0 : ref.id;
        if (sticker && collectionStickerId) {
            var _s = {
                id: sticker.id,
                icon: sticker.icon,
                name: sticker.name,
                collection_id: collectionStickerId
            };
            return sendSticker(_s);
        }
    }, [
        atd,
        collection,
        giftAtd,
        sendSticker,
        sticker,
        collectionStickers
    ]);
    (0,react.useEffect)(function() {
        if (collection != "send-atd") refetchSticker();
    }, [
        collection,
        refetchSticker
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-px-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-items-center tw-w-11/12 tw-overflow-x-auto",
                        children: [
                            collectionStickers.map(function(c) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-pr-6 tw-text-secondary-70 tw-cursor-pointer ".concat(collection === c.name ? "tw-font-semibold" : ""),
                                    onClick: function() {
                                        return setCollection(c.name);
                                    },
                                    children: c.name
                                }, "sticker-" + c.id);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-pr-6 tw-text-secondary-70 tw-cursor-pointer ".concat(collection === "send-atd" ? "tw-font-semibold" : ""),
                                onClick: function() {
                                    return setCollection("send-atd");
                                },
                                children: masterData === null || masterData === void 0 ? void 0 : (ref = masterData.live_stream_gift_atd) === null || ref === void 0 ? void 0 : ref.title
                            }, "send-atd")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-h-28 tw-mt-4 tw-leading-0 tw-justify-start tw-items-start tw-overflow-y-auto tw-flex tw-flex-wrap tw-relative ",
                        children: isLoadingStickers ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-col-span-5 tw-flex tw-items-center tw-justify-center tw-w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* Loading */.g, {})
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                collection === "send-atd" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "tw-text-sm",
                                            children: [
                                                masterData === null || masterData === void 0 ? void 0 : (ref1 = masterData.live_stream_gift_atd) === null || ref1 === void 0 ? void 0 : ref1.description,
                                                "."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "tw-mt-3 tw-grid tw-grid-cols-3 tw-gap-3",
                                            children: [
                                                masterData === null || masterData === void 0 ? void 0 : (ref2 = masterData.live_stream_gift_atd) === null || ref2 === void 0 ? void 0 : ref2.amounts.map(function(price) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "tw-cursor-pointer tw-relative tw-flex tw-items-center tw-border tw-rounded-5 tw-overflow-hidden before:tw-w-[5px] before:tw-h-full before:tw-bg-primary-main before:tw-absolute before:tw-left-0 before:tw-top-0 tw-p-2 ".concat(atd === price ? "tw-bg-[#EFFDFA] tw-border-primary-main" : "tw-bg-white tw-border-[#9E9E9E]"),
                                                            onClick: function() {
                                                                return setAtd(price);
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                                                    src: "/diamond-kam.png",
                                                                    alt: "diamond",
                                                                    className: "tw-w-5 tw-h-5 tw-mr-1"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "tw-flex tw-flex-col",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                            className: "tw-font-bold tw-text-xs tw-text-primary-main",
                                                                            children: [
                                                                                price,
                                                                                " ATD ~"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "tw-font-bold tw-text-xs tw-text-warning-90",
                                                                            children: (0,app/* toMoney */.KP)(price * 100000, t)
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }, "amount-".concat(price))
                                                    });
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
                                                    className: "tw-cursor-pointer tw-relative tw-flex tw-items-center tw-border tw-border-primary-main tw-rounded-5 tw-overflow-hidden before:tw-w-[5px] before:tw-h-full before:tw-bg-primary-main before:tw-absolute before:tw-left-0 before:tw-top-0 tw-p-2 tw-bg-primary-main",
                                                    url: layouts_shared/* PagePath.AccountDepositPage */._.AccountDepositPage,
                                                    target: "_blank",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(DiamondPlus/* DiamondPlusIcon */.y, {}),
                                                            className: "tw-w-5 tw-h-5 tw-text-white"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "tw-flex tw-flex-col tw-text-white",
                                                            children: "Nạp ATD"
                                                        })
                                                    ]
                                                }, "deposit-atd")
                                            ]
                                        })
                                    ]
                                }),
                                collection != "send-atd" && listSticker.map(function(s) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                        className: "tw-relative tw-mr-3 tw-mb-3 tw-rounded-5 tw-cursor-pointer ".concat((sticker === null || sticker === void 0 ? void 0 : sticker.id) == s.id ? "tw-border tw-border-primary-main" : ""),
                                        onClick: function() {
                                            return setSticker(s);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                            alt: s.name,
                                            src: s.icon,
                                            className: "tw-w-10 tw-h-10 xl:tw-w-14 xl:tw-h-14",
                                            objectFit: "cover"
                                        })
                                    }, "sticker-".concat(s.name));
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-flex tw-justify-end tw-pt-2 tw-px-4 tw-bg-white tw-relative tw-z-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    className: "tw-text-white tw-text-13 tw-bg-primary-main tw-px-4 tw-py-1 tw-uppercase !tw-w-auto !tw-rounded-5",
                    onClick: function() {
                        return chooseSticker();
                    },
                    loading: isLoading,
                    children: "Gửi tặng"
                })
            })
        ]
    });
};
/* harmony default export */ var chat_SendSticker = (/*#__PURE__*/(0,react.memo)(SendSticker));

;// CONCATENATED MODULE: ./features/livestream/detail/partials/chat/Comments/SendCommentBlock.tsx
















// eslint-disable-next-line react/display-name
var SendCommentBlock = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var _$ref;
    var userId = props.userId, liveStreamId = props.liveStreamId, t = props.t, status = props.status, collectionStickers = props.collectionStickers, setDisabled = props.setDisabled, isAuth = props.isAuth, onShowProducts = props.onShowProducts;
    var _$ref1 = (0,react.useState)(false), showSticker = _$ref1[0], setShowSticker = _$ref1[1];
    var _$ref2 = (0,react.useState)(false), show = _$ref2[0], setShow = _$ref2[1];
    var _$ref3 = (0,react.useState)(false), isLoadingGift = _$ref3[0], setLoadingGift = _$ref3[1];
    var commentRef = (0,react.useRef)(null);
    var _$ref4 = (0,api/* useAddCommentQuery */.fk)({
        onSuccess: function() {
            reset();
            react_hot_toast_esm/* default.success */.ZP.success(t("detail.message.add-comment-success"));
            setTimeout(function() {
                setDisabled();
            }, 5000);
        }
    }), mutate = _$ref4.mutate, isLoading = _$ref4.isLoading;
    var _$ref5 = (0,api/* useGiftAtd */.Mz)({
        onSuccess: function() {
            react_hot_toast_esm/* default.success */.ZP.success("Cảm ơn bạn đ\xe3 tặng atd cho An Thư. Ch\xfac bạn một ng\xe0y tốt l\xe0nh");
        },
        onError: function(param) {
            var message = param.message;
            react_hot_toast_esm/* default.error */.ZP.error(message);
        }
    }), mutateGiftAtd = _$ref5.mutate;
    var _$ref6 = (0,index_esm/* useForm */.cI)({
        defaultValues: detail_const/* FormChatDefault */.Ww,
        resolver: (0,yup_module/* yupResolver */.X)(es/* object */.Ry({
            comment: es/* string */.Z_().trim().required(t("detail.message.comment-required"))
        }))
    }), reset = _$ref6.reset, control = _$ref6.control, handleSubmit = _$ref6.handleSubmit, errors = _$ref6.formState.errors;
    var onCommentClick = handleSubmit(function(data) {
        if (isLoading || !userId) return;
        mutate((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
            comment: data.comment,
            user_id: userId || 0,
            live_stream_id: +liveStreamId,
            images: null
        }));
        commentRef.current && commentRef.current.scrollToBottom();
    });
    var keyPress = (0,react.useCallback)(function(e) {
        if (e.keyCode === 13) {
            if (!isAuth) return setShow(true);
            return onCommentClick();
        }
    }, [
        isAuth,
        onCommentClick
    ]);
    // const keyPress = (e: any) => {
    //   if (e.keyCode === 13) {
    //     onCommentClick();
    //   }
    // };
    var onStickerClick = function() {
        setShowSticker(!showSticker);
    };
    var _$ref7 = (0,api/* useSendSticker */.Hu)({
        onSuccess: function() {
            setShowSticker(false);
        }
    }), SendStickerMutate = _$ref7.mutate, isLoadingSendSticker = _$ref7.isLoading;
    (0,react.useImperativeHandle)(ref, function() {
        return {
            sendComment: function(data) {
                mutate(data);
            }
        };
    });
    var sendSticker = function(s) {
        var payload = {
            live_stream_id: liveStreamId,
            sticker_id: s.id,
            sticker_collection_id: s.collection_id
        };
        setShowSticker(false);
        SendStickerMutate(payload);
    };
    var giftAtd = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(amount) {
            var data, _;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoadingGift(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            5,
                            6
                        ]);
                        return [
                            4,
                            (0,api/* getSession */.Gg)()
                        ];
                    case 2:
                        data = _state.sent().data;
                        return [
                            4,
                            mutateGiftAtd({
                                amount: amount,
                                liveId: liveStreamId,
                                sessionId: data.session_id
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 4:
                        _ = _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 5:
                        setLoadingGift(false);
                        setShowSticker(false);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function giftAtd(amount) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                children: showSticker && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                    initial: "stickerWrapperInitial",
                    exit: "stickerWrapperExit",
                    animate: "stickerWrapperAnimate",
                    transition: {
                        duration: 0.3
                    },
                    variants: {
                        stickerWrapperInitial: {
                            opacity: 0
                        },
                        stickerWrapperExit: {
                            opacity: 0
                        },
                        stickerWrapperAnimate: {
                            opacity: 1
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-absolute bottom-100-12 tw-left-0 tw-w-full tw-bg-white tw-rounded-5 tw-drop-shadow-lg custom-polygon-sticker",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-relative tw-w-full",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-absolute tw-text-secondary-70 tw-top-3 tw-right-3 tw-flex tw-items-center tw-justify-center tw-w-5 tw-h-5 tw-cursor-pointer",
                                    onClick: function() {
                                        return setShowSticker(false);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                        className: "tw-w-3 tw-h-3",
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(XIcon/* XIcon */.b, {})
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-w-full tw-py-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chat_SendSticker, {
                                        giftAtd: giftAtd,
                                        t: t,
                                        isLoading: isLoadingSendSticker || isLoadingGift,
                                        collectionStickers: collectionStickers,
                                        sendSticker: sendSticker
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-gap-x-2 tw-items-center ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        loading: isLoading,
                        onClick: onShowProducts,
                        className: "tw-flex tw-justify-center tw-p-2 !tw-rounded-full !tw-w-fit tw-bg-primary-main",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                            className: "tw-w-4 tw-h-4",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Diamond/* DiamondField */.p, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-flex-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* TextField */.n, {
                            name: "comment",
                            control: control,
                            showErrorMessage: false,
                            variant: Input/* InputVariant.Outlined */.J.Outlined,
                            error: (_$ref = errors.comment) === null || _$ref === void 0 ? void 0 : _$ref.message,
                            onKeyDown: keyPress,
                            placeholder: t("detail.form.label.comment") + "...",
                            containerClassName: "tw-bg-white tw-rounded-full !tw-border-0 tw-border-white tw-flex-1",
                            className: "tw-px-2 custom-placeholder "
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        disabled: !userId,
                        loading: isLoading,
                        onClick: onCommentClick,
                        className: "tw-flex tw-justify-center tw-p-2 !tw-rounded-full !tw-w-fit tw-bg-primary-main",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                            className: "tw-w-4 tw-h-4",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Send/* SendIcon */.j, {})
                        })
                    }),
                    status === detail_const/* LiveStreamStatus.LIVE_NOW */.zN.LIVE_NOW && !!collectionStickers.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        disabled: !userId,
                        loading: isLoading,
                        onClick: onStickerClick,
                        className: "tw-flex tw-justify-center tw-p-2 !tw-rounded-full !tw-w-fit tw-bg-primary-main",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                            className: "tw-w-4 tw-h-4",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlowerIcon, {})
                        })
                    })
                ]
            }),
            show && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
                onClose: function() {
                    return setShow(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-flex tw-flex-col tw-items-center tw-justify-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-text-center",
                            children: "Vui l\xf2ng đăng nhập để sử dụng t\xednh năng n\xe0y."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            className: "tw-mt-4 !tw-underline tw-text-lg",
                            url: {
                                pathname: layouts_shared/* PagePath.LoginPage */._.LoginPage
                            },
                            children: "Đăng nhập"
                        })
                    ]
                })
            })
        ]
    });
});

// EXTERNAL MODULE: ./components/icons/Chat/index.tsx
var Chat = __webpack_require__(29934);
// EXTERNAL MODULE: ./components/icons/Wallet/index.tsx
var Wallet = __webpack_require__(63075);
// EXTERNAL MODULE: ./components/icons/Auction/index.tsx
var Auction = __webpack_require__(45150);
;// CONCATENATED MODULE: ./models/auction.ts
var AuctionType;
(function(AuctionType) {
    AuctionType["Public"] = "PUBLIC";
    AuctionType["InvitedOnly"] = "INVITED_ONLY";
})(AuctionType || (AuctionType = {}));

// EXTERNAL MODULE: ./features/livestream/detail/partials/chat/Comments/AuctionModal.tsx
var AuctionModal = __webpack_require__(59394);
;// CONCATENATED MODULE: ./features/livestream/detail/partials/chat/Comments/ProductAuction.tsx








var ProductAuction = function(param) {
    var product = param.product, productId = param.productId, isDiscount = param.isDiscount, t = param.t, userId = param.userId;
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(false), open = ref3[0], setOpen = ref3[1];
    var ref4 = (0,react.useState)(false), isInvited = ref4[0], setIsInvited = ref4[1];
    var handleOpenModal = function() {
        setOpen(true);
    };
    (0,react.useEffect)(function() {
        var ref;
        if ((ref = product.auction) === null || ref === void 0 ? void 0 : ref.id) {
            if (product.auction.type === AuctionType.InvitedOnly) {
                var ref1;
                (0,api/* getAuctionInvitedUsers */.vc)((ref1 = product.auction) === null || ref1 === void 0 ? void 0 : ref1.id).then(function(param) {
                    var data = param.data;
                    setIsInvited(!!data);
                });
            } else {
                setIsInvited(true);
            }
        }
    }, [
        product
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-bg-white tw-rounded-5 tw-p-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: " tw-flex tw-gap-x-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                url: {
                                    pathname: layouts_shared/* PagePath.ProductDetailPage */._.ProductDetailPage,
                                    query: {
                                        id: "".concat((0,app/* createHandle */.UR)(product.product_name), "-").concat(productId, "-").concat(product.product_code)
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-relative !tw-w-20 !tw-h-20 tw-bg-center tw-bg-no-repeat tw-bg-cover tw-rounded-5",
                                    style: {
                                        backgroundImage: "url('".concat((0,app/* getProductImage */.C6)(product.images), "')")
                                    },
                                    title: product.product_name,
                                    children: isDiscount && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tw-w-6 tw-h-6 tw-absolute tw-top-2 tw-right-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                                src: "/sale.png",
                                                className: "tw-w-full tw-h-full",
                                                alt: "sale"
                                            })
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-flex-1 tw-flex tw-flex-col tw-gap-y-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                        className: "tw-w-full",
                                        url: {
                                            pathname: layouts_shared/* PagePath.ProductDetailPage */._.ProductDetailPage,
                                            query: {
                                                id: "".concat((0,app/* createHandle */.UR)(product.product_name), "-").concat(productId, "-").concat(product.product_code)
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            className: "tw-text-primary-main tw-text-sm tw-font-semibold tw-line-clamp-1",
                                            dangerouslySetInnerHTML: {
                                                __html: product.product_name
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tw-text-13 ",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tw-text-secondary-70",
                                                children: product.product_code
                                            }),
                                            "-",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("i", {
                                                children: [
                                                    "Gi\xe1 khởi điểm:",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "tw-text-warning-90 tw-font-semibold",
                                                        children: (0,app/* toMoney */.KP)(((ref = product.auction) === null || ref === void 0 ? void 0 : ref.origin_price) || 0, t, layouts_shared/* PriceSymbol.$ */.hb.$)
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tw-text-sm",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("i", {
                                            children: [
                                                "Gi\xe1 hiện tại:",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "tw-text-warning-90 tw-font-semibold",
                                                    children: (0,app/* toMoney */.KP)(((ref1 = product.auction) === null || ref1 === void 0 ? void 0 : ref1.sell_price) || 0, t, layouts_shared/* PriceSymbol.$ */.hb.$)
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-flex tw-justify-end",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                            onClick: handleOpenModal,
                            disabled: ((ref2 = product.auction) === null || ref2 === void 0 ? void 0 : ref2.status) !== layouts_shared/* AuctionStatus.Started */.wo.Started || !userId || !isInvited,
                            className: "tw-bg-warning-90 tw-text-white tw-uppercase tw-flex tw-items-center tw-gap-x-2 tw-border-warning-90 tw-text-xs tw-w-max tw-px-6 tw-py-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Auction/* AuctionIcon */.C, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Đấu gi\xe1"
                                })
                            ]
                        })
                    })
                ]
            }),
            open && productId && /*#__PURE__*/ (0,jsx_runtime.jsx)(AuctionModal/* default */.Z, {
                t: t,
                handleCloseModal: function() {
                    return setOpen(false);
                },
                productCode: product.product_code,
                productName: product.product_name,
                productId: productId
            })
        ]
    });
};
/* harmony default export */ var Comments_ProductAuction = (ProductAuction);

// EXTERNAL MODULE: ./libs/cookies/index.ts
var cookies = __webpack_require__(60377);
// EXTERNAL MODULE: ./libs/product/index.tsx + 1 modules
var libs_product = __webpack_require__(56666);
;// CONCATENATED MODULE: ./features/livestream/detail/partials/chat/Comments/PinProduct.tsx









var PinnedProduct = function(props) {
    var ref;
    var isAuth = (0,cookies/* getAuth */.v0)().isAuth;
    var profile = (0,contexts_profile/* useProfile */.Un)();
    var product = props.product, productId = props.productId, t = props.t, isDisabled = props.isDisabled, userId = props.userId, onConsultClick = props.onConsultClick, liveStreamId = props.liveStreamId, orderProductId = props.orderProductId;
    var ref1 = libs_product/* productUtils.preprocessProductDiscount */.O.preprocessProductDiscount(product, profile), hasDiscount = ref1.hasDiscount, hasUserLevelDiscount = ref1.hasUserLevelDiscount, matchedUserLevelDiscount = ref1.matchedUserLevelDiscount;
    if (matchedUserLevelDiscount) {
        product.product_discount = matchedUserLevelDiscount;
    }
    if (product.is_auction) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Comments_ProductAuction, {
        t: t,
        userId: userId,
        product: product,
        productId: productId,
        isDiscount: hasDiscount
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-bg-white tw-rounded-5 tw-flex tw-gap-x-2 tw-p-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                url: {
                    pathname: layouts_shared/* PagePath.ProductDetailPage */._.ProductDetailPage,
                    query: {
                        id: "".concat((0,app/* createHandle */.UR)(product.product_name), "-").concat(productId, "-").concat(product.product_code)
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-relative !tw-w-20 !tw-h-20 tw-bg-center tw-bg-no-repeat tw-bg-cover tw-rounded-5",
                    style: {
                        backgroundImage: "url('".concat((0,app/* getProductImage */.C6)(product.images), "')")
                    },
                    title: product.product_name,
                    children: hasDiscount && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-w-6 tw-h-6 tw-absolute tw-top-2 tw-right-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                src: "/sale.png",
                                className: "tw-w-full tw-h-full",
                                alt: "sale"
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex-1 tw-flex tw-flex-col tw-gap-y-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                        className: "tw-w-full tw-h-full",
                        url: {
                            pathname: layouts_shared/* PagePath.ProductDetailPage */._.ProductDetailPage,
                            query: {
                                id: "".concat((0,app/* createHandle */.UR)(product.product_name), "-").concat(productId, "-").concat(product.product_code)
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            className: "tw-text-primary-main tw-text-sm tw-font-semibold tw-line-clamp-1",
                            dangerouslySetInnerHTML: {
                                __html: product.product_name
                            }
                        })
                    }),
                    !product.quotation ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-text-secondary-70 tw-flex tw-flex-wrap tw-items-center tw-gap-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "tw-text-13",
                                        children: product.product_code
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tw-w-[2px] tw-h-[2px] tw-bg-secondary-70 tw-rounded-full"
                                    }),
                                    product.product_discount && hasDiscount ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tw-flex",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "tw-text-warning-90 tw-font-medium tw-text-13",
                                            children: (0,app/* toMoney */.KP)(product.price - product.price * ((ref = product.product_discount) === null || ref === void 0 ? void 0 : ref.discount) / 100, t)
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tw-flex tw-text-xs tw-items-center lg:tw-gap-x-1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "tw-text-warning-90 tw-font-medium tw-text-13",
                                            children: (0,app/* toMoney */.KP)(product.price, t)
                                        })
                                    })
                                ]
                            }),
                            hasUserLevelDiscount && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-text-xs tw-mt-1",
                                children: !isAuth ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "tw-text-secondary-70",
                                    children: "Đăng nhập để xem ưu đ\xe3i của bạn"
                                }) : matchedUserLevelDiscount ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "tw-text-secondary-70",
                                    children: "Hạng thẻ của bạn chưa c\xf3 ưu đ\xe3i"
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-text-secondary-70",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "tw-text-13",
                                    children: product.product_code
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-text-warning-90",
                                    children: t("layout:btn.contact")
                                })
                            ]
                        })
                    }),
                    !product.quotation && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-justify-end tw-gap-x-4 lg:tw-gap-x-2 xl:tw-gap-x-4 tw-text-xs tw-items-center",
                        children: [
                            isDisabled || product.quantity <= 0 || orderProductId === productId ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                                disabled: !userId,
                                className: "!tw-rounded-5 tw-py-1 tw-uppercase tw-px-3 tw-opacity-70 tw-flex tw-items-center !tw-w-[120px] lg:!tw-w-[110px] xl:!tw-w-[120px]",
                                variant: Button/* ButtonVariant.Outlined */.W.Outlined,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chat/* ChatLineIcon */.C, {}),
                                        className: "tw-w-4 tw-h-4 tw-mr-3 lg:tw-mr-2 xl:tw-mr-3"
                                    }),
                                    t("layout:btn.consult")
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                                disabled: !userId,
                                onClick: onConsultClick,
                                className: "!tw-rounded-5 tw-py-1 tw-uppercase tw-px-3 tw-opacity-70 tw-flex tw-items-center !tw-w-[120px] lg:!tw-w-[110px] xl:!tw-w-[120px] tw-text-base lg:tw-text-sm xl:tw-text-base",
                                variant: Button/* ButtonVariant.Outlined */.W.Outlined,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chat/* ChatLineIcon */.C, {}),
                                        className: "tw-w-4 tw-h-4 tw-mr-3 lg:tw-mr-2 xl:tw-mr-3"
                                    }),
                                    t("layout:btn.consult")
                                ]
                            }),
                            product.quantity <= 0 || product.status != layouts_shared/* ProductStatus.Availability */.Pt.Availability || orderProductId === productId ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                                disabled: true,
                                className: "!tw-rounded-5 tw-text-white tw-bg-primary-main tw-py-1 tw-px-3 tw-flex tw-items-center tw-justify-center !tw-w-max lg:!tw-w-[125px] xl:!tw-w-max tw-uppercase tw-text-base lg:tw-text-sm xl:tw-text-base",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wallet/* WalletIcon */.o, {}),
                                        className: "tw-w-4 tw-h-4 tw-mr-3 lg:tw-mr-2 xl:tw-mr-3 tw-text-white"
                                    }),
                                    t("layout:btn.deposited")
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
                                url: {
                                    pathname: layouts_shared/* PagePath.ProductDepositPage */._.ProductDepositPage,
                                    query: {
                                        id: productId,
                                        stream_id: liveStreamId
                                    }
                                },
                                target: "_blank",
                                className: "tw-bg-primary-main !tw-text-white !tw-w-max lg:!tw-w-[125px] xl:!tw-w-max tw-gap-x-1 tw-border tw-px-3 tw-py-1 tw-rounded-5 tw-flex tw-items-center tw-justify-center tw-uppercase tw-text-base lg:tw-text-sm xl:tw-text-base",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wallet/* WalletIcon */.o, {}),
                                        className: "tw-w-4 tw-h-4 tw-mr-3 lg:tw-mr-2 xl:tw-mr-3 tw-text-white"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: t("layout:btn.order")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./features/products/detail/api.ts
var detail_api = __webpack_require__(17852);
// EXTERNAL MODULE: ./features/consults/chat/api.ts
var chat_api = __webpack_require__(96732);
;// CONCATENATED MODULE: ./features/livestream/detail/partials/chat/index.tsx













var ChatPartial = function(props) {
    var liveStreamId = props.liveStreamId, status = props.status, pinnedProduct = props.pinnedProduct, isAuth = props.isAuth, t = props.t, collectionStickers = props.collectionStickers, messageData = props.messageData, retry = props.retry, showLotteryBtn = props.showLotteryBtn, hideLotteryBtn = props.hideLotteryBtn, lotteryGame = props.lotteryGame, commentList = props.commentList, defaultOffset = props.defaultOffset;
    var LOTTERY_URL = "https://landing.anthu.vn/lottery/user.html";
    var profile = (0,contexts_profile/* useProfile */.Un)();
    var userId = (profile === null || profile === void 0 ? void 0 : profile.id) || null;
    var commentRef = (0,react.useRef)(null);
    var sendCommentRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(), orderDeposit = ref[0], setOrderDeposit = ref[1];
    var ref1 = (0,react.useState)(), ticket = ref1[0], setTicket = ref1[1];
    var ref2 = (0,react.useState)(), winnerAuction = ref2[0], setWinnerAuction = ref2[1];
    var ref3 = (0,react.useState)(false), isDisabled = ref3[0], setIsDisabled = ref3[1];
    var ref4 = (0,react.useState)(false), showPopup = ref4[0], setShowPopup = ref4[1];
    var ref5 = (0,react.useState)(), orderId = ref5[0], setOrderId = ref5[1];
    var ref6 = (0,react.useState)((lotteryGame === null || lotteryGame === void 0 ? void 0 : lotteryGame.status) || layouts_shared/* LotteryGameStatus.Ended */.Ck.Ended), gameStatus = ref6[0], setGameStatus = ref6[1];
    var ref7 = (0,react.useState)((lotteryGame === null || lotteryGame === void 0 ? void 0 : lotteryGame.id) || null), gameId = ref7[0], setGameId = ref7[1];
    var ref8 = (0,react.useState)(""), myReward = ref8[0], setMyReward = ref8[1];
    var ref9 = (0,react.useState)(true), showProducts = ref9[0], setShowProducts = ref9[1];
    var ref10 = (0,api/* useTicketByUserQuery */.$E)({
        lottery_game_id: gameId || ""
    }, {
        enabled: false,
        retry: false,
        onSuccess: function(param) {
            var data = param.data;
            return setTicket(data.number);
        },
        onError: function() {
            return setTicket(undefined);
        }
    }), refetchTicketByUser = ref10.refetch;
    var ref11 = (0,chat_api/* useCreateOrderChat */.qW)({}), sendMessage = ref11.mutate;
    var ref12 = (0,api/* useCreateChatConversation */.uJ)({
        onSuccess: function(param) {
            var data = param.data;
            var conversation = data.conversation;
            sendMessage({
                id: conversation.id,
                data: {
                    content: "TV ".concat(conversation.type_code),
                    images: [],
                    type: "text"
                }
            });
        },
        onError: function(param) {
            var message = param.message;
        }
    }), mutate = ref12.mutate, isCreateChatConversationLoading = ref12.isLoading;
    var ref13 = (0,detail_api/* useFetchConversationByProductQuery */.uK)((pinnedProduct === null || pinnedProduct === void 0 ? void 0 : pinnedProduct.product_id) || 0, {
        retry: 0,
        enabled: false,
        onSuccess: function(data) {
            var ref = data.data || {}, id = ref.id, type_code = ref.type_code, type = ref.type;
            sendMessage({
                id: id,
                data: {
                    content: "TV ".concat(type_code),
                    images: [],
                    type: "text"
                }
            });
        },
        onError: function() {
            return mutate({
                title: (pinnedProduct === null || pinnedProduct === void 0 ? void 0 : pinnedProduct.products.product_name) || "",
                type_id: (pinnedProduct === null || pinnedProduct === void 0 ? void 0 : pinnedProduct.product_id) || 0,
                type_image: (0,app/* getProductImage */.C6)(pinnedProduct === null || pinnedProduct === void 0 ? void 0 : pinnedProduct.products.images) || "",
                type_code: (pinnedProduct === null || pinnedProduct === void 0 ? void 0 : pinnedProduct.products.product_code) || "",
                type: conversation/* ConversationType.Product */.i.Product
            });
        }
    }), fetchConversation = ref13.refetch, isFetchConversationLoading = ref13.isLoading;
    var setEndLottery = function() {
        setTimeout(function() {
            setGameStatus(layouts_shared/* LotteryGameStatus.Ended */.Ck.Ended);
            setTicket(undefined);
        }, 10000);
    };
    var setProductOrder = function(code, image, fullName, id) {
        setTimeout(function() {
            setOrderDeposit({
                productCode: code,
                productImage: image,
                fullname: fullName,
                isShow: true,
                id: id
            });
        }, 500);
    };
    (0,react.useEffect)(function() {
        if (gameId && showLotteryBtn && !ticket) refetchTicketByUser();
    }, [
        gameId,
        showLotteryBtn,
        ticket,
        refetchTicketByUser
    ]);
    (0,react.useEffect)(function() {
        if ((messageData === null || messageData === void 0 ? void 0 : messageData.method) === layouts_shared/* LotterySocketMethod.UserConfirmTicket */.Sf.UserConfirmTicket) {
            var ref;
            if (((ref = messageData === null || messageData === void 0 ? void 0 : messageData.data.users) === null || ref === void 0 ? void 0 : ref.id) === userId) refetchTicketByUser();
        }
        if ((messageData === null || messageData === void 0 ? void 0 : messageData.method) === layouts_shared/* LotterySocketMethod.OpenLottery */.Sf.OpenLottery) {
            setGameStatus(layouts_shared/* LotteryGameStatus.Pending */.Ck.Pending);
            setGameId(messageData.data.lottery_game_id || null);
        }
        if ((messageData === null || messageData === void 0 ? void 0 : messageData.method) === layouts_shared/* LotterySocketMethod.EndLottery */.Sf.EndLottery) {
            setEndLottery();
        }
        if ((messageData === null || messageData === void 0 ? void 0 : messageData.method) === layouts_shared/* LotterySocketMethod.AdminPickTicketLottery */.Sf.AdminPickTicketLottery) {
            var ref1;
            if (((ref1 = messageData === null || messageData === void 0 ? void 0 : messageData.data.users) === null || ref1 === void 0 ? void 0 : ref1.id) === userId) {
                var ref2;
                setShowPopup(true);
                setMyReward(((ref2 = messageData.data.prize) === null || ref2 === void 0 ? void 0 : ref2.name) || "");
            }
        }
        if ((messageData === null || messageData === void 0 ? void 0 : messageData.method) === layouts_shared/* LiveProductMethod.CreateOrder */.zN.CreateOrder) {
            var ref3, ref4;
            if (((ref3 = messageData === null || messageData === void 0 ? void 0 : messageData.data.product) === null || ref3 === void 0 ? void 0 : ref3.id) && ((ref4 = messageData === null || messageData === void 0 ? void 0 : messageData.data.product) === null || ref4 === void 0 ? void 0 : ref4.id) === (pinnedProduct === null || pinnedProduct === void 0 ? void 0 : pinnedProduct.product_id)) {
                var ref5, ref6, ref7, ref8;
                var dataOrder = messageData === null || messageData === void 0 ? void 0 : messageData.data;
                setOrderId((ref5 = dataOrder.product) === null || ref5 === void 0 ? void 0 : ref5.id);
                setProductOrder(pinnedProduct === null || pinnedProduct === void 0 ? void 0 : pinnedProduct.products.product_code, (dataOrder === null || dataOrder === void 0 ? void 0 : (ref6 = dataOrder.product) === null || ref6 === void 0 ? void 0 : ref6.image) || "", (dataOrder === null || dataOrder === void 0 ? void 0 : (ref7 = dataOrder.users) === null || ref7 === void 0 ? void 0 : ref7.fullname) || "", (dataOrder === null || dataOrder === void 0 ? void 0 : (ref8 = dataOrder.product) === null || ref8 === void 0 ? void 0 : ref8.id) || 0);
            }
        }
        if ((messageData === null || messageData === void 0 ? void 0 : messageData.method) === layouts_shared/* LiveProductMethod.AuctionEnded */.zN.AuctionEnded) {
            if (messageData.data.winner) {
                var winner = messageData.data.winner;
                setWinnerAuction({
                    fullName: winner.fullname,
                    productCode: messageData.data.product_code || ""
                });
            }
        }
    }, [
        messageData,
        pinnedProduct,
        refetchTicketByUser,
        userId
    ]);
    (0,react.useEffect)(function() {
        if ((pinnedProduct === null || pinnedProduct === void 0 ? void 0 : pinnedProduct.product_id) !== (orderDeposit === null || orderDeposit === void 0 ? void 0 : orderDeposit.id)) {
            setOrderDeposit(undefined);
        }
    }, [
        orderDeposit === null || orderDeposit === void 0 ? void 0 : orderDeposit.id,
        pinnedProduct === null || pinnedProduct === void 0 ? void 0 : pinnedProduct.product_id
    ]);
    var ref14 = (0,api/* useCreateCodeTicketQuery */.ll)({
        onSuccess: function(param) {
            var code = param.data.code;
            if (!code) return;
            var newWindow = window.open("".concat(LOTTERY_URL, "?code=").concat(encodeURIComponent(code)), "_blank");
            if (newWindow) newWindow.opener = null;
        }
    }), mutateCreateCode = ref14.mutate, loadingCreateCode = ref14.isLoading;
    var onConsultClick = function() {
        if (pinnedProduct) {
            setIsDisabled(true);
            sendCommentRef.current && sendCommentRef.current.sendComment({
                comment: "TV ".concat(pinnedProduct.products.product_code),
                user_id: userId || 0,
                live_stream_id: +liveStreamId,
                images: null
            });
            return fetchConversation();
        }
    };
    var directPlayGame = function() {
        if (gameId && gameStatus === layouts_shared/* LotteryGameStatus.Pending */.Ck.Pending) mutateCreateCode({
            lottery_game_id: gameId
        });
    };
    var sendComment = function(code) {
        if (code) {
            setIsDisabled(true);
            sendCommentRef.current && sendCommentRef.current.sendComment({
                comment: "TV ".concat(code),
                user_id: userId || 0,
                live_stream_id: +liveStreamId,
                images: null
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-bg-muted-90 tw-rounded-5 tw-h-80-screen tw-flex tw-flex-col tw-gap-y-4 tw-p-4 tw-justify-between",
                children: [
                    showLotteryBtn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: gameStatus !== layouts_shared/* LotteryGameStatus.Ended */.Ck.Ended && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-flex tw-bg-white tw-rounded-5 tw-px-4 tw-pt-2 tw-pb-4 tw-gap-x-2 tw-relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                    src: "/confetti-flat.gif",
                                    alt: "confetti",
                                    className: "tw-w-16 tw-h-16"
                                }),
                                ticket ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tw-flex-1 tw-text-primary-main",
                                    children: [
                                        t("detail.label.joined-lottery"),
                                        ": ",
                                        ticket
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tw-flex-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "tw-text-primary-main",
                                            children: t("detail.label.invite-join-lottery")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tw-flex tw-justify-end tw-mt-4 tw-w-full",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                disabled: loadingCreateCode || gameStatus !== layouts_shared/* LotteryGameStatus.Pending */.Ck.Pending,
                                                className: "tw-bg-primary-main tw-text-xs tw-uppercase tw-text-white tw-py-1 tw-px-6 tw-rounded !tw-w-max",
                                                onClick: directPlayGame,
                                                children: t("layout:btn.join")
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-absolute tw-right-2 tw-cursor-pointer",
                                    onClick: hideLotteryBtn,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(XLine/* XLineIcon */.p, {}),
                                        className: "tw-w-4 tw-h-4 tw-text-secondary-70"
                                    })
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: pinnedProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)(PinnedProduct, {
                            t: t,
                            product: pinnedProduct === null || pinnedProduct === void 0 ? void 0 : pinnedProduct.products,
                            productId: pinnedProduct === null || pinnedProduct === void 0 ? void 0 : pinnedProduct.product_id,
                            isDisabled: isDisabled,
                            orderProductId: orderId,
                            userId: userId,
                            liveStreamId: liveStreamId,
                            onConsultClick: onConsultClick
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Comments, {
                        ref: commentRef,
                        isAuth: isAuth,
                        liveId: liveStreamId,
                        retry: retry,
                        messageData: messageData,
                        commentList: commentList,
                        defaultOffset: defaultOffset,
                        isShowProducts: showProducts,
                        sendComment: sendComment,
                        hiddenProducts: function() {
                            return setShowProducts(false);
                        },
                        t: t
                    }),
                    status === detail_const/* LiveStreamStatus.LIVE_NOW */.zN.LIVE_NOW && pinnedProduct && orderDeposit && orderDeposit.isShow && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-gap-y-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-p-2 tw-flex tw-rounded tw-items-center a-flip-left",
                                style: {
                                    backgroundColor: "#EDFFFC"
                                },
                                children: [
                                    orderDeposit.productImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                        className: "tw-h-8 tw-w-8",
                                        alt: orderDeposit.productCode,
                                        src: orderDeposit.productImage
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "tw-font-light tw-flex tw-flex-1 tw-ml-2",
                                        style: {
                                            color: "#11695A",
                                            fontSize: "13px"
                                        },
                                        children: [
                                            "Qu\xfd kh\xe1ch ",
                                            orderDeposit.fullname,
                                            " đ\xe3 cọc th\xe0nh c\xf4ng ",
                                            orderDeposit.productCode
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    winnerAuction && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-gap-y-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-p-2 tw-flex tw-rounded tw-items-center a-flip-left",
                                style: {
                                    backgroundColor: "#FFF7E3"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "tw-font-light tw-flex tw-flex-1 tw-ml-2",
                                    style: {
                                        color: "#A54400",
                                        fontSize: "13px"
                                    },
                                    children: [
                                        "Qu\xfd kh\xe1ch ",
                                        winnerAuction.fullName,
                                        " đ\xe3 đấu gi\xe1 th\xe0nh c\xf4ng ",
                                        winnerAuction.productCode
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SendCommentBlock, {
                        ref: sendCommentRef,
                        t: t,
                        liveStreamId: liveStreamId,
                        status: status,
                        collectionStickers: collectionStickers,
                        setDisabled: function() {
                            return setIsDisabled(false);
                        },
                        isAuth: isAuth,
                        userId: userId,
                        onShowProducts: function() {
                            return setShowProducts(function(prev) {
                                return !prev;
                            });
                        }
                    })
                ]
            }),
            showPopup && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalCustom/* ModalCustom */.w, {
                className: "tw-rounded-2xl tw-overflow-hidden tw-w-60 md:tw-w-96 tw-flex tw-items-center tw-flex-col",
                childrenClass: "!tw-gap-y-0 tw-w-full tw-items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                        src: "/confetti-flat.gif",
                        alt: "confetti",
                        className: "tw-w-52 tw-h-52"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-mt-2 tw-text-center",
                        children: "Ch\xfac mừng bạn đ\xe3 chiến thắng"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-mt-1 tw-text-center",
                        children: myReward
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            className: "tw-bg-primary-main tw-text-white tw-mt-4 tw-w-full tw-rounded-full",
                            onClick: function() {
                                return setShowPopup(false);
                            },
                            children: "OK"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var chat = (ChatPartial);

// EXTERNAL MODULE: ./features/livestream/detail/partials/player/index.tsx + 6 modules
var player = __webpack_require__(77649);
// EXTERNAL MODULE: ./components/form/SearchVideo/index.tsx
var SearchVideo = __webpack_require__(89777);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 25 modules
var esm = __webpack_require__(10268);
;// CONCATENATED MODULE: ./features/livestream/detail/partials/breadcrumb/index.tsx


var BreadCrumbPartial = function(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-flex tw-gap-x-2 tw-items-center tw-font-normal tw-text-base !tw-text-secondary-70",
        children: [
            "Trực tiếp \xa0",
            " > ",
            "\xa0",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "tw-line-clamp-1 tw-flex-1",
                children: title
            })
        ]
    });
};
/* harmony default export */ var breadcrumb = (/*#__PURE__*/(0,react.memo)(BreadCrumbPartial));

// EXTERNAL MODULE: ./components/ui/MetaTag/index.tsx
var MetaTag = __webpack_require__(42031);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./components/ui/JsonLd/index.tsx
var JsonLd = __webpack_require__(59904);
;// CONCATENATED MODULE: ./features/livestream/detail/layout.tsx
















var LiveVideoDetailLayout = function(param) {
    var liveVideo = param.liveVideo, isAuth = param.isAuth, collectionStickers = param.collectionStickers, comments = param.comments, offset = param.offset;
    var ref, ref1, ref2, ref3;
    var t = (0,esm/* useTranslation */.$G)([
        "live-video",
        "layout"
    ]).t;
    var getPinnedProduct = function(productsRange) {
        var ref;
        if (productsRange.length <= 0) return null;
        var p = productsRange.find(function(p) {
            return p.status === detail_const/* LiveStreamStatus.LIVE_NOW */.zN.LIVE_NOW;
        });
        if (p && p.product_id && ((ref = p.products) === null || ref === void 0 ? void 0 : ref.status) !== layouts_shared/* ProductStatus.Hide */.Pt.Hide) {
            return p;
        }
        return null;
    };
    var ref4 = (0,react.useState)(), pinnedProduct = ref4[0], setPinnedProduct = ref4[1];
    (0,react.useEffect)(function() {
        setPinnedProduct(getPinnedProduct(liveVideo.live_stream_product) || detail_const/* PinnedProductDefault */.UC);
    }, [
        liveVideo
    ]);
    var ref5 = (0,react.useState)(false), showLotteryBtn = ref5[0], setShowLotteryBtn = ref5[1];
    var ref6 = (0,react.useState)(null), message = ref6[0], setMessage = ref6[1];
    var ref7 = (0,react.useState)(null), waitingToReconnect = ref7[0], setWaitingToReconnect = ref7[1];
    var ref8 = (0,react.useState)(0), retry = ref8[0], setRetry = ref8[1];
    var ref9 = (0,react.useRef)(null);
    var timeOut = (0,react.useRef)(null);
    var clientRef = (0,react.useRef)(null);
    var ref10 = (0,api/* useFetchTrackingVideo */.yk)(liveVideo.id, {
        enabled: false,
        refetchOnWindowFocus: false
    }), refetchTracking = ref10.refetch;
    (0,react.useEffect)(function() {
        var ref = (0,cookies/* getAuth */.v0)(), isAuth = ref.isAuth, token = ref.token;
        if (waitingToReconnect) {
            return;
        }
        if (!isAuth) refetchTracking();
        if (isAuth && !clientRef.current) {
            var ws = new WebSocket("".concat("wss://api.anthu.tech/ws/realtime" || 0, "?token=").concat(token));
            clientRef.current = ws;
            ws.onopen = function() {
                var socketPayload = {
                    method: "subscribe",
                    type: "unicast",
                    channels: [
                        {
                            id: layouts_shared/* SocketChanel.LiveStream */.y1.LiveStream,
                            object_id: liveVideo.id
                        }
                    ]
                };
                ws.send(JSON.stringify(socketPayload));
                if (!retry) {
                    refetchTracking();
                    setRetry(function(prev) {
                        return prev + 1;
                    });
                }
                timeOut.current = setInterval(function() {
                    var socketPayload = {
                        method: "ping"
                    };
                    ws.send(JSON.stringify(socketPayload));
                }, 15000);
            };
            ws.onmessage = function(evt) {
                var m = JSON.parse(evt.data);
                if (m === null || m === void 0 ? void 0 : m.data) {
                    setMessage(m);
                    clearTimeout(ref9.current);
                }
                ref9.current = setTimeout(function() {
                    setMessage(null);
                }, 5000);
            };
            ws.onclose = function() {
                if (clientRef.current) {
                    console.log("ws closed by server");
                } else {
                    console.log("ws closed by app component unmount");
                }
                setWaitingToReconnect(true);
                setTimeout(function() {
                    return setWaitingToReconnect(null);
                }, 5000);
            };
            return function() {
                ws.close();
                console.log("closed");
                clearInterval(timeOut.current);
                timeOut.current = null;
                clientRef.current = null;
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        liveVideo.id,
        waitingToReconnect
    ]);
    var lotteryGame = ((ref = liveVideo.lottery_game) === null || ref === void 0 ? void 0 : ref.find(function(g) {
        return g.status !== layouts_shared/* LotteryGameStatus.Ended */.Ck.Ended;
    })) || null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTag/* default */.Z, {
                // nhiều buổi live trùng tên → thêm ngày live để title không bị trùng
                title: liveVideo.name ? "".concat(liveVideo.name.trim()).concat(liveVideo.start_datetime ? " – Live " + dayjs_min_default()(liveVideo.start_datetime).format("DD/MM/YYYY") : "") : t("detail.title"),
                description: (liveVideo.description || liveVideo.name || t("detail.title")).slice(0, 160),
                image: liveVideo.images[0].url || ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(JsonLd/* default */.Z, {
                schema: {
                    "@context": "https://schema.org",
                    "@type": "VideoObject",
                    name: liveVideo.name,
                    description: liveVideo.description || liveVideo.name,
                    thumbnailUrl: ((ref1 = liveVideo.images[0]) === null || ref1 === void 0 ? void 0 : ref1.url) || "",
                    uploadDate: liveVideo.start_datetime,
                    contentUrl: liveVideo.link
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container tw-pt-8 tw-pb-12 tw-mx-auto md:tw-border-t tw-border-primary-main",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb, {
                        title: liveVideo.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        className: "tw-hidden",
                        children: [
                            " ",
                            liveVideo.name
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: "tw-hidden",
                        children: [
                            " ",
                            liveVideo.name
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: "tw-hidden",
                        children: [
                            " ",
                            liveVideo.description
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-flex-col tw-mt-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-grid tw-grid-cols-1 sm:tw-grid-cols-12 tw-gap-y-4 tw-gap-x-0 sm:tw-gap-x-4 sm:tw-gap-y-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "sm:tw-col-span-6 md:tw-col-span-7 tw-relative tw-flex tw-flex-col",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchVideo/* default */.Z, {
                                                t: t
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "tw-relative tw-mt-4 tw-h-full tw-flex tw-flex-1 tw-rounded-5 tw-overflow-hidden",
                                                children: liveVideo.link && /*#__PURE__*/ (0,jsx_runtime.jsx)(player/* default */.Z, {
                                                    url: liveVideo.link,
                                                    liveImage: (ref2 = liveVideo.images[0]) === null || ref2 === void 0 ? void 0 : ref2.url,
                                                    pinnedProduct: pinnedProduct,
                                                    setPinnedProduct: setPinnedProduct,
                                                    liveStreamId: liveVideo.id,
                                                    liveStatus: liveVideo.status,
                                                    productsRange: (0,util/* productsRangeBuilder */.g)(liveVideo.live_stream_product),
                                                    messageData: message,
                                                    lotteryGame: lotteryGame,
                                                    luckyDetail: liveVideo === null || liveVideo === void 0 ? void 0 : liveVideo.lucky,
                                                    t: t,
                                                    isAuth: isAuth,
                                                    showLotteryBtn: function() {
                                                        return setShowLotteryBtn(true);
                                                    },
                                                    hideLotteryBtn: function() {
                                                        return setShowLotteryBtn(false);
                                                    },
                                                    sticker: message === null || message === void 0 ? void 0 : (ref3 = message.data) === null || ref3 === void 0 ? void 0 : ref3.sticker_icon
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "sm:tw-col-span-6 md:tw-col-span-5",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chat, {
                                            hideLotteryBtn: function() {
                                                return setShowLotteryBtn(false);
                                            },
                                            showLotteryBtn: showLotteryBtn,
                                            liveStreamId: liveVideo.id,
                                            status: liveVideo.status,
                                            pinnedProduct: pinnedProduct,
                                            commentList: comments,
                                            isAuth: isAuth,
                                            collectionStickers: collectionStickers,
                                            messageData: message,
                                            lotteryGame: lotteryGame,
                                            defaultOffset: offset,
                                            products: liveVideo.live_stream_product,
                                            t: t,
                                            retry: waitingToReconnect || false
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-mt-16",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(list, {
                                    t: t
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var layout = (LiveVideoDetailLayout);

;// CONCATENATED MODULE: ./features/livestream/detail/index.ts

/* harmony default export */ var detail = (layout);


/***/ })

}]);